import React from "react";
import { get, map } from "lodash";
import cls from "classnames";
import { Img } from "../../ImgV2/Img";
import { BiographyType } from "imagica-corekit/dist/base/api/viewBuilderTyped/TopicWithRelatedPeopleData";
import { SignificanceType } from "imagica-corekit/dist/base/api/viewBuilderTyped/TopicWithRelatedDetailData";
import { RANDOM_COLORS } from "../../Constant";
import styles from "./WaterfallFlowList.module.scss";
export function WaterfallFlowList(props) {
  function getRandomClass(index) {
    return RANDOM_COLORS[index];
  }
  if (props.componentName === "TopicWithRelatedPeople") {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.personSignificance
    }, map(props.list, function (item, index) {
      var _item$biography_detai, _item$biography_detai2, _item$biography_detai3;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: styles.significanceBox
      }, (item === null || item === void 0 || (_item$biography_detai = item.biography_detail) === null || _item$biography_detai === void 0 ? void 0 : _item$biography_detai.type) === BiographyType.IMAGE ? /*#__PURE__*/React.createElement(Img, {
        className: "topicWithRelatedPeopleSignificanceImg",
        imgKey: item === null || item === void 0 || (_item$biography_detai2 = item.biography_detail) === null || _item$biography_detai2 === void 0 ? void 0 : _item$biography_detai2.biography_value
      }) : /*#__PURE__*/React.createElement("p", {
        className: styles.biographyValue
      }, item === null || item === void 0 || (_item$biography_detai3 = item.biography_detail) === null || _item$biography_detai3 === void 0 ? void 0 : _item$biography_detai3.biography_value));
    }));
  }
  if (props.componentName === "TopicWithRelatedDetail") {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.personSignificance
    }, map(props.list, function (significance, sIndex) {
      var _ref, _topic_detail;
      var topicDetail = (_ref = (_topic_detail = significance === null || significance === void 0 ? void 0 : significance.topic_detail) !== null && _topic_detail !== void 0 ? _topic_detail : significance) !== null && _ref !== void 0 ? _ref : {};
      return /*#__PURE__*/React.createElement("div", {
        key: sIndex,
        className: cls(styles.significanceBox, styles[getRandomClass(sIndex)])
      }, topicDetail.type === SignificanceType.IMAGE ? /*#__PURE__*/React.createElement(Img, {
        className: "topicWithRelatedPeopleSignificanceImg",
        imgKey: topicDetail.value
      }) : topicDetail.type === SignificanceType.TEXT && topicDetail.value instanceof Object ? /*#__PURE__*/React.createElement("div", {
        className: styles.headerBox
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.title
      }, get(topicDetail, "value.topic_detail_title", "")), /*#__PURE__*/React.createElement("p", {
        className: styles.summary
      }, get(topicDetail, "value.topic_detail_body", ""))) : /*#__PURE__*/React.createElement("div", {
        className: styles.headerBox
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.summary
      }, get(topicDetail, "value", ""))));
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}